import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateLectureQuizQuestion as updateLectureQuizQuestionApi } from "../../../../services/dashboard/apiQuizes";

export function useUpdateQuizQuestion() {
  const queryClient = useQueryClient();

  const {
    mutate: updateQuizQuesion,
    isPending: isUpdating,
    error,
  } = useMutation({
    mutationFn: updateLectureQuizQuestionApi,
    onSuccess: () => {
      toast.success("تم تعديل السؤال بنجاح");

      queryClient.invalidateQueries({
        queryKey: ["quizQuestionsDB"],
      });
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { updateQuizQuesion, isUpdating, error };
}
